import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Popup from 'components/Popup/Popup';
import Typography from 'components/Typography/Typography';

export const EulaPopupStyled = styled(Popup)`
  // use your custom style for ".popup-overlay"
  &-overlay {
  }
  // use your custom style for ".popup-content"
  &-content {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    padding: 20px 16px;

    ${({ theme }) => `
    ${theme.devices.tablet} {
      max-height: 80vh;
      max-width: 90vw;
      align-items: center;
      justify-content: center;
      }
    `}
  }
`;

export const FlexContainerStyled = styled(FlexContainer)`
  height: 100%;
  ${({ theme }) => `
    ${theme.devices.tablet} {
      min-width: 600px;
      max-height: 600px;
      }
    `}
`;

export const TypographyTitleStyled = styled(Typography)`
  margin-bottom: 1.875rem;
  ${({ theme }) => `
    ${theme.devices.tablet} {
      width: 50%;
      }
    `}
`;

export const TypographyContentStyled = styled.div`
  width: 100%;
  max-width: 650px;
  max-height: 400px;
  margin-bottom: 1.875rem;
  overflow: auto;
  text-align: justify;
  line-height: 1.3;
  p {
    margin-bottom: 8px;
    padding-right: 6px;
  }
  strong {
    font-weight: ${({ theme }) => theme.fontWeight.medium};
  }
  b {
    display: block;
    padding-right: 6px;
    font-weight: normal;
    margin: 24px 0 12px;
    text-transform: uppercase;
  }
  em {
    display: block;
    padding-right: 6px;
    font-size: small;
    opacity: 0.8;
  }
`;

export const EulaButtonStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }) => theme.fontSize['2xl']};

  &:first-child {
    margin-right: 1rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
        height: 38px;
        font-size: ${theme.fontSize.lg};
    }
    `}
`;
